var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['modal', {'is-active': _vm.is_active}]},[_c('div',{staticClass:"modal-background",on:{"click":function($event){return _vm.$emit('close')}}}),_c('div',{staticClass:"modal-content",style:({width: '90%'})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }